export const projectsData = [{
  project_img_dark: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709277305/sexm7s0ouqxgrzfeiixh.png",
  project_img: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709277305/sexm7s0ouqxgrzfeiixh.png",

  title: "E-Commerce",
  description: "This is a Solo Project. I developed this website with a tech stack MongoDB , Express.js, React, Redux, React Router DOM, Node.js, Tailwind CSS, Razorpay. This project is responsive in mobile, desktop, tab. The primary objective of this project is to provide users with a seamless and secure platform for shopping cycle. I have given best of my efforts in this project.",
  tech_stack: [{
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
    name: "react",
  },
  {
    url: "https://w7.pngwing.com/pngs/956/695/png-transparent-mongodb-original-wordmark-logo-icon-thumbnail.png",
    name: "mongoDB",
  },
  {
    url: "https://adware-technologies.s3.amazonaws.com/uploads/technology/thumbnail/20/express-js.png",
    name: "express.js",
  },
  {
    url: "https://cdn-icons-png.flaticon.com/512/919/919825.png",
    name: "node.js",
  },
  {
    url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
    name: "html",
  },
  {
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
    name: "css",
  },
  {
    url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
    name: "js",
  },
  {
    url: "https://external-preview.redd.it/h2z8O8aaWTsWpXyYHVdqG_ErnFzLgfNmZk1mqLnMJRY.jpg?auto=webp&s=84b3a8854a0e79f0b89409b3f6cc9883e1ebe6f5",
    name: "tailwind css",
  },
  {
    url: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    name: "github",
  },
  ],
  link: "https://mern-e-commerce-sand.vercel.app/",
  github: "https://github.com/AnandAK07/MERN-E-Commerce",
}, {
  project_img_dark: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709281417/hz8c5p7pnhudbjmducph.png",
  project_img: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709281417/hz8c5p7pnhudbjmducph.png",

  title: "Nyka Admin Dashboard",
  description: "This is a Solo Project. I have developed this website with a tech stack MongoDB , Express.js, React, Redux, React Router DOM, Node.js, Tailwind CSS, Figma Design template. The primary objective of this project is to replicate the Figma template as it is.I tried to replicate 100%  pixel perfect.  I have given best of my efforts in this project.",
  tech_stack: [{
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
    name: "react",
  },
  {
    url: "https://w7.pngwing.com/pngs/956/695/png-transparent-mongodb-original-wordmark-logo-icon-thumbnail.png",
    name: "mongoDB",
  },
  {
    url: "https://adware-technologies.s3.amazonaws.com/uploads/technology/thumbnail/20/express-js.png",
    name: "express.js",
  },
  {
    url: "https://cdn-icons-png.flaticon.com/512/919/919825.png",
    name: "node.js",
  },
  {
    url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
    name: "html",
  },
  {
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
    name: "css",
  },
  {
    url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
    name: "js",
  },
  {
    url: "https://external-preview.redd.it/h2z8O8aaWTsWpXyYHVdqG_ErnFzLgfNmZk1mqLnMJRY.jpg?auto=webp&s=84b3a8854a0e79f0b89409b3f6cc9883e1ebe6f5",
    name: "tailwind css",
  },
  {
    url: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    name: "github",
  },
  ],
  link: "https://nyka-one.vercel.app/",
  github: "https://github.com/AnandAK07/Nyka",
},
{
  project_img_dark: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709282117/axpe0xmx69ivf82lpilo.png",
  project_img: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709282117/axpe0xmx69ivf82lpilo.png",

  title: "Gem garden jewelry store",
  description: "This is a Collaborative Project. We developed this website with a tech stack Mongodb, Express.js, React, Redux, React Router DOM, Node.js, CSS, Firebase, razorpay. The primary objective of this project is to provide users with seamless and secure platform for shopping jewelry.We have implemented razorpay payment gateway. We had build this project with our efforts to do our best in this project.",
  tech_stack: [{
    url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
    name: "html",
  },
  {
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
    name: "css",
  },
  {
    url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
    name: "js",
  },
  {
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUEuytZnw-WdBb6ZjrN_uS8OzZ6QnLVnMvUw&usqp=CAU",
    name: "bootstrap",
  },
  {
    url: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    name: "github",
  },
  ],
  link: "https://gem-garden-jewelry-store.vercel.app/",
  github: "https://github.com/AnandAK07/gem-garden-jewelry-store",
},
{
  project_img: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709281907/icm5rhjuu65lmi3zxnpt.png",
  project_img_dark: "https://res.cloudinary.com/ddoccbpq7/image/upload/v1709281907/icm5rhjuu65lmi3zxnpt.png",

  title: "BlueFly ",
  description: "This is a Collaborative Project. We developed this website with a tech stack HTML, CSS and Javascript,Bootstrap to acheive this. In this project we have tried to clone the “BlueFly” website.The primary objective of this project is to provide users with a seamless and secure platform for shopping experience. We had build this project with all our efforts to do our best in this project.",
  tech_stack: [{
    url: "https://cdn-icons-png.flaticon.com/512/732/732212.png",
    name: "html",
  },
  {
    url: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png",
    name: "css",
  },
  {
    url: "https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg",
    name: "js",
  },
  {
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUEuytZnw-WdBb6ZjrN_uS8OzZ6QnLVnMvUw&usqp=CAU",
    name: "bootstrap",
  },
  {
    url: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    name: "github",
  },
  ],
  link: "https://blue-fly-ruddy.vercel.app/",
  github: "https://github.com/AnandAK07/BlueFly",
}
];